import React, { FunctionComponent } from "react";

import { VehicleManufacturerEntry } from "../../../stores/slices/packageEditorSlice";
import { VehicleList } from "../VehicleMapping/VehicleList";
import { VehicleLoader } from "../VehicleMapping/VehicleLoader";
import { VehicleMappingPayload } from "../useVehicleMaping";

export const Vehicles: FunctionComponent<{
  data: VehicleMappingPayload;
  forceVehicleLoaderMode: boolean;
  setForceVehicleLoaderMode(forceVehicleLoaderMode: boolean): void;
  setModelsAreLoading(modelsAreLoading: boolean): void;
  setVehicleManufacturers(
    vehicleManufacturers: VehicleManufacturerEntry[]
  ): void;
  setVehicleMappingCriteria(value: string): void;
  toggleVehicleManufacturerId(manufacturerId: number): void;
  toggleVehicleYearId(yearId: number): void;
  vehicleManufacturerIds: number[];
  vehicleMappingCriteria: string;
  vehicleYearIds: number[];
}> = ({
  data,
  forceVehicleLoaderMode,
  setForceVehicleLoaderMode,
  setModelsAreLoading,
  setVehicleManufacturers,
  setVehicleMappingCriteria,
  toggleVehicleManufacturerId,
  toggleVehicleYearId,
  vehicleManufacturerIds,
  vehicleMappingCriteria,
  vehicleYearIds,
}) => {
  if (forceVehicleLoaderMode || !data.totalAvailable) {
    return (
      <VehicleLoader
        setModelsAreLoading={setModelsAreLoading}
        setVehicleManufacturers={setVehicleManufacturers}
        toggleVehicleManufacturerId={toggleVehicleManufacturerId}
        toggleVehicleYearId={toggleVehicleYearId}
        vehicleManufacturerIds={vehicleManufacturerIds}
        vehicleYearIds={vehicleYearIds}
      />
    );
  }

  return (
    <VehicleList
      onAddVehicles={(): void => {
        setForceVehicleLoaderMode(true);
      }}
      criteria={vehicleMappingCriteria}
      data={data}
      setCriteria={setVehicleMappingCriteria}
    />
  );
};
